import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Mount from '../Mount'; 


const Privacy = () => {
  const [action, setAction] = useState("Privacy");

  const handlePrivacyClick = () => {
    setAction("Privacy"); 
  };
  
  const handleTermsClick = () => {
    setAction("Terms");
  };
  
  return (
    <div className='setter'>
      <Helmet>
        <title>{action === "Privacy" ? "Privacy" : "Terms"}|Contranorm Media & Production&nbsp;&trade;</title>
      </Helmet>
      <Mount>
        <div className="page">
          <h1>
            <div className="text">{action === "Privacy" ? "Privacy Policy" : "Terms & Conditions"}</div>
          </h1>
          <div className="underline"></div>
          
          <>
            {action === "Privacy" ? (
              <>
                <p>
                  At Contranorm Media & Production, we believe that your information should be safe, secure, and protected. We work hard to minimize the risks associated with collecting and storing your information.
                  One thing that we will never do is sell your data. We recognize that protecting private, personally-identifiable information is a big deal, and we've taken a number of steps to demonstrate our commitment to protecting your privacy.
                </p>
                <p>
                  <Link to="/policies">Learn</Link>&nbsp; how we collect, use, and protect your personal information.
                </p>
              </>
            ) : (
              <>
                <p>
                  Our terms cover your use of our services and the legal agreements between you and us.
                  By soliciting our service(s), accessing our content, using our website(s) or purchasing our product(s), you agree to all terms and conditions outlined in Contranorm Media & Production's Terms & Conditions. This includes accepting any changes to these Terms & Conditions as they are updated and posted.
                </p>
                <p>
                  Read the full&nbsp;<Link to="/policies">documentation</Link>&nbsp;here.
                </p>
              </>
            )}
          </>

        
          
          <div className="submit-container">
            <div className={action === "Privacy" ? "submit gray" : "submit"} onClick={handlePrivacyClick}>Privacy</div>
            <div className={action === "Terms" ? "submit gray" : "submit"} onClick={handleTermsClick}>Terms</div>
          </div>
        </div>
      </Mount>
    </div>
  );
};

export default Privacy;
